/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  CustomerOrder,
  CustomerOrderResponse,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchCustomerOrdersRequest,
  SearchCustomerOrdersResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    CustomerOrderFromJSON,
    CustomerOrderToJSON,
    CustomerOrderResponseFromJSON,
    CustomerOrderResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchCustomerOrdersRequestFromJSON,
    SearchCustomerOrdersRequestToJSON,
    SearchCustomerOrdersResponseFromJSON,
    SearchCustomerOrdersResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnCustomerOrderByIdRequest {
    customerOrderId: string;
    contentType: CreateChangeRequestOnCustomerOrderByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateCustomerOrderRequest {
    contentType: CreateCustomerOrderContentTypeEnum;
    xBOLMemberIdentifier: string;
    customerOrder: CustomerOrder;
    id?: string;
    source?: boolean;
    accept?: CreateCustomerOrderAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateCustomerOrderEventRequest {
    customerOrderId: string;
    contentType: CreateCustomerOrderEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateCustomerOrderEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteCustomerOrderACLAuthorizationByMemberIdRequest {
    customerOrderId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteCustomerOrderByIdRequest {
    customerOrderId: string;
    traceparent?: string;
}

export interface DeleteCustomerOrderEventByIdRequest {
    customerOrderId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnCustomerOrderByIdRequest {
    customerOrderId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface GetCustomerOrderACLAuthorizationByMemberIdRequest {
    customerOrderId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetCustomerOrderACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetCustomerOrderACLByIdRequest {
    customerOrderId: string;
    at?: string;
    revision?: string;
    accept?: GetCustomerOrderACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetCustomerOrderByIdRequest {
    customerOrderId: string;
    at?: string;
    revision?: string;
    accept?: GetCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface GetCustomerOrderEventsRequest {
    customerOrderId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetCustomerOrderEventsAcceptEnum;
    traceparent?: string;
}

export interface GetCustomerOrderMetadataByIdRequest {
    customerOrderId: string;
    accept?: GetCustomerOrderMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfCustomerOrderByIdRequest {
    customerOrderId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchCustomerOrderByIdRequest {
    customerOrderId: string;
    contentType: PatchCustomerOrderByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    customerOrder: CustomerOrder;
    revision?: string;
    accept?: PatchCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchCustomerOrderGetRequest {
    id?: string;
    searchBody?: SearchCustomerOrdersRequest;
    accept?: SearchCustomerOrderGetAcceptEnum;
    traceparent?: string;
}

export interface SearchCustomerOrdersPostRequest {
    contentType: SearchCustomerOrdersPostContentTypeEnum;
    searchCustomerOrdersRequest: SearchCustomerOrdersRequest;
    limit?: number;
    offset?: number;
    accept?: SearchCustomerOrdersPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnCustomerOrderByIdRequest {
    customerOrderId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnCustomerOrderByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateCustomerOrderByIdRequest {
    customerOrderId: string;
    contentType: UpdateCustomerOrderByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    customerOrder: CustomerOrder;
    revision?: string;
    accept?: UpdateCustomerOrderByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertCustomerOrderACLAuthorizationByIdRequest {
    customerOrderId: string;
    contentType: UpsertCustomerOrderACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertCustomerOrderACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsCustomerOrdersApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific CustomerOrder resource, identified by its `CustomerOrderId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the CustomerOrder resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a CustomerOrder resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the CustomerOrder resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a CustomerOrder
     */
    async createChangeRequestOnCustomerOrderByIdRaw(requestParameters: CreateChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling createChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/change-requests`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific CustomerOrder resource, identified by its `CustomerOrderId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the CustomerOrder resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a CustomerOrder resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the CustomerOrder resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a CustomerOrder
     */
    async createChangeRequestOnCustomerOrderById(requestParameters: CreateChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnCustomerOrderByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new CustomerOrder.  When creating a CustomerOrder, the value of the header `X-BOL-Member-Identifier` defines the CustomerOrder\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a CustomerOrder, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the CustomerOrder and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the CustomerOrder, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the CustomerOrder.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a CustomerOrder
     */
    async createCustomerOrderRaw(requestParameters: CreateCustomerOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerOrderResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createCustomerOrder().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createCustomerOrder().'
            );
        }

        if (requestParameters['customerOrder'] == null) {
            throw new runtime.RequiredError(
                'customerOrder',
                'Required parameter "customerOrder" was null or undefined when calling createCustomerOrder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerOrderToJSON(requestParameters['customerOrder']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerOrderResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new CustomerOrder.  When creating a CustomerOrder, the value of the header `X-BOL-Member-Identifier` defines the CustomerOrder\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a CustomerOrder, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the CustomerOrder and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the CustomerOrder, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the CustomerOrder.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a CustomerOrder
     */
    async createCustomerOrder(requestParameters: CreateCustomerOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerOrderResponse | null | undefined > {
        const response = await this.createCustomerOrderRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a CustomerOrder by `customerOrderId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a CustomerOrder resource. 
     * Create an Event of a CustomerOrder
     */
    async createCustomerOrderEventRaw(requestParameters: CreateCustomerOrderEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling createCustomerOrderEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createCustomerOrderEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createCustomerOrderEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createCustomerOrderEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/events`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a CustomerOrder by `customerOrderId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a CustomerOrder resource. 
     * Create an Event of a CustomerOrder
     */
    async createCustomerOrderEvent(requestParameters: CreateCustomerOrderEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCustomerOrderEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a CustomerOrder resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the CustomerOrder resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a CustomerOrder resource. 
     * Delete an authorization of an access control list of a CustomerOrder by memberId
     */
    async deleteCustomerOrderACLAuthorizationByMemberIdRaw(requestParameters: DeleteCustomerOrderACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling deleteCustomerOrderACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteCustomerOrderACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteCustomerOrderACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a CustomerOrder resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the CustomerOrder resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a CustomerOrder resource. 
     * Delete an authorization of an access control list of a CustomerOrder by memberId
     */
    async deleteCustomerOrderACLAuthorizationByMemberId(requestParameters: DeleteCustomerOrderACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerOrderACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific CustomerOrder resource, identified by its `CustomerOrderId`.  - When a CustomerOrder is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a CustomerOrder resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a CustomerOrder resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a CustomerOrder resource. 
     * Delete a CustomerOrder by customerOrderId
     */
    async deleteCustomerOrderByIdRaw(requestParameters: DeleteCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling deleteCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific CustomerOrder resource, identified by its `CustomerOrderId`.  - When a CustomerOrder is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a CustomerOrder resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a CustomerOrder resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a CustomerOrder resource. 
     * Delete a CustomerOrder by customerOrderId
     */
    async deleteCustomerOrderById(requestParameters: DeleteCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerOrderByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a CustomerOrder resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a CustomerOrder resource. 
     * Delete an event of a CustomerOrder by id
     */
    async deleteCustomerOrderEventByIdRaw(requestParameters: DeleteCustomerOrderEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling deleteCustomerOrderEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteCustomerOrderEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteCustomerOrderEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a CustomerOrder resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a CustomerOrder resource. 
     * Delete an event of a CustomerOrder by id
     */
    async deleteCustomerOrderEventById(requestParameters: DeleteCustomerOrderEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCustomerOrderEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given CustomerOrder, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the CustomerOrder resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a CustomerOrder by changeRequestId
     */
    async getChangeRequestOnCustomerOrderByIdRaw(requestParameters: GetChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given CustomerOrder, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the CustomerOrder resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a CustomerOrder by changeRequestId
     */
    async getChangeRequestOnCustomerOrderById(requestParameters: GetChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a CustomerOrder resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a CustomerOrder resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a CustomerOrder by memberId
     */
    async getCustomerOrderACLAuthorizationByMemberIdRaw(requestParameters: GetCustomerOrderACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getCustomerOrderACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a CustomerOrder resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a CustomerOrder resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a CustomerOrder by memberId
     */
    async getCustomerOrderACLAuthorizationByMemberId(requestParameters: GetCustomerOrderACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getCustomerOrderACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific CustomerOrder resource, identified by its `CustomerOrderId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the CustomerOrder and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a CustomerOrder resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a CustomerOrder for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getCustomerOrderACLByIdRaw(requestParameters: GetCustomerOrderACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/acl`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific CustomerOrder resource, identified by its `CustomerOrderId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the CustomerOrder and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a CustomerOrder resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a CustomerOrder for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getCustomerOrderACLById(requestParameters: GetCustomerOrderACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getCustomerOrderACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific CustomerOrder by its `CustomerOrderId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this CustomerOrder resource. 
     * Get a CustomerOrder by customerOrderId
     */
    async getCustomerOrderByIdRaw(requestParameters: GetCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerOrderResponse>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerOrderResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific CustomerOrder by its `CustomerOrderId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this CustomerOrder resource. 
     * Get a CustomerOrder by customerOrderId
     */
    async getCustomerOrderById(requestParameters: GetCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerOrderResponse> {
        const response = await this.getCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a CustomerOrder by `customerOrderId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a CustomerOrder resource. 
     * List Events of a CustomerOrder
     */
    async getCustomerOrderEventsRaw(requestParameters: GetCustomerOrderEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/events`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a CustomerOrder by `customerOrderId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a CustomerOrder resource. 
     * List Events of a CustomerOrder
     */
    async getCustomerOrderEvents(requestParameters: GetCustomerOrderEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getCustomerOrderEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific CustomerOrder by its `CustomerOrderId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a CustomerOrder metadata by customerOrderId
     */
    async getCustomerOrderMetadataByIdRaw(requestParameters: GetCustomerOrderMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling getCustomerOrderMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/metadata`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific CustomerOrder by its `CustomerOrderId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a CustomerOrder metadata by customerOrderId
     */
    async getCustomerOrderMetadataById(requestParameters: GetCustomerOrderMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getCustomerOrderMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified CustomerOrder, identified by its `CustomerOrderId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given CustomerOrder resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a CustomerOrder resource. 
     * Get a list of ChangeRequest for CustomerOrder
     */
    async listChangeRequestsOfCustomerOrderByIdRaw(requestParameters: ListChangeRequestsOfCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling listChangeRequestsOfCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/change-requests`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified CustomerOrder, identified by its `CustomerOrderId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given CustomerOrder resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a CustomerOrder resource. 
     * Get a list of ChangeRequest for CustomerOrder
     */
    async listChangeRequestsOfCustomerOrderById(requestParameters: ListChangeRequestsOfCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing CustomerOrder identified by its `CustomerOrderId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a CustomerOrder resource. 
     * Partially update a CustomerOrder by applying a JSON Merge Patch change request
     */
    async patchCustomerOrderByIdRaw(requestParameters: PatchCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerOrderResponse>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling patchCustomerOrderById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchCustomerOrderById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchCustomerOrderById().'
            );
        }

        if (requestParameters['customerOrder'] == null) {
            throw new runtime.RequiredError(
                'customerOrder',
                'Required parameter "customerOrder" was null or undefined when calling patchCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerOrderToJSON(requestParameters['customerOrder']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerOrderResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing CustomerOrder identified by its `CustomerOrderId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a CustomerOrder resource. 
     * Partially update a CustomerOrder by applying a JSON Merge Patch change request
     */
    async patchCustomerOrderById(requestParameters: PatchCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerOrderResponse> {
        const response = await this.patchCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of CustomerOrder resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on CustomerOrders.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of CustomerOrder resources. 
     * Search for CustomerOrders
     */
    async searchCustomerOrderGetRaw(requestParameters: SearchCustomerOrderGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchCustomerOrdersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchCustomerOrdersResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of CustomerOrder resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on CustomerOrders.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of CustomerOrder resources. 
     * Search for CustomerOrders
     */
    async searchCustomerOrderGet(requestParameters: SearchCustomerOrderGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchCustomerOrdersResponse> {
        const response = await this.searchCustomerOrderGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of CustomerOrder resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on CustomerOrders.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of CustomerOrder resources. 
     * Search for CustomerOrders
     */
    async searchCustomerOrdersPostRaw(requestParameters: SearchCustomerOrdersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchCustomerOrdersResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchCustomerOrdersPost().'
            );
        }

        if (requestParameters['searchCustomerOrdersRequest'] == null) {
            throw new runtime.RequiredError(
                'searchCustomerOrdersRequest',
                'Required parameter "searchCustomerOrdersRequest" was null or undefined when calling searchCustomerOrdersPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchCustomerOrdersRequestToJSON(requestParameters['searchCustomerOrdersRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchCustomerOrdersResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of CustomerOrder resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on CustomerOrders.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of CustomerOrder resources. 
     * Search for CustomerOrders
     */
    async searchCustomerOrdersPost(requestParameters: SearchCustomerOrdersPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchCustomerOrdersResponse> {
        const response = await this.searchCustomerOrdersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given CustomerOrder, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a CustomerOrder resource. 
     * Accept or reject a ChangeRequest on a  CustomerOrder using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnCustomerOrderByIdRaw(requestParameters: UpdateChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling updateChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnCustomerOrderById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given CustomerOrder, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a CustomerOrder resource. 
     * Accept or reject a ChangeRequest on a  CustomerOrder using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnCustomerOrderById(requestParameters: UpdateChangeRequestOnCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing CustomerOrder identified by its `CustomerOrderId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a CustomerOrder resource. 
     * Update an existing CustomerOrder by creating and applying a change request
     */
    async updateCustomerOrderByIdRaw(requestParameters: UpdateCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerOrderResponse>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling updateCustomerOrderById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateCustomerOrderById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateCustomerOrderById().'
            );
        }

        if (requestParameters['customerOrder'] == null) {
            throw new runtime.RequiredError(
                'customerOrder',
                'Required parameter "customerOrder" was null or undefined when calling updateCustomerOrderById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerOrderToJSON(requestParameters['customerOrder']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerOrderResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing CustomerOrder identified by its `CustomerOrderId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a CustomerOrder resource. 
     * Update an existing CustomerOrder by creating and applying a change request
     */
    async updateCustomerOrderById(requestParameters: UpdateCustomerOrderByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerOrderResponse> {
        const response = await this.updateCustomerOrderByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific CustomerOrder resource, identified by its `CustomerOrderId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a CustomerOrder resource. 
     * Upsert (create or update) an authorization of an access control list of a CustomerOrder.
     */
    async upsertCustomerOrderACLAuthorizationByIdRaw(requestParameters: UpsertCustomerOrderACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['customerOrderId'] == null) {
            throw new runtime.RequiredError(
                'customerOrderId',
                'Required parameter "customerOrderId" was null or undefined when calling upsertCustomerOrderACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertCustomerOrderACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertCustomerOrderACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/customer-orders/{customerOrderId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"customerOrderId"}}`, encodeURIComponent(String(requestParameters['customerOrderId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific CustomerOrder resource, identified by its `CustomerOrderId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a CustomerOrder resource. 
     * Upsert (create or update) an authorization of an access control list of a CustomerOrder.
     */
    async upsertCustomerOrderACLAuthorizationById(requestParameters: UpsertCustomerOrderACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertCustomerOrderACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnCustomerOrderByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnCustomerOrderByIdContentTypeEnum = typeof CreateChangeRequestOnCustomerOrderByIdContentTypeEnum[keyof typeof CreateChangeRequestOnCustomerOrderByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnCustomerOrderByIdAcceptEnum = typeof CreateChangeRequestOnCustomerOrderByIdAcceptEnum[keyof typeof CreateChangeRequestOnCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const CreateCustomerOrderContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateCustomerOrderContentTypeEnum = typeof CreateCustomerOrderContentTypeEnum[keyof typeof CreateCustomerOrderContentTypeEnum];
/**
 * @export
 */
export const CreateCustomerOrderAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateCustomerOrderAcceptEnum = typeof CreateCustomerOrderAcceptEnum[keyof typeof CreateCustomerOrderAcceptEnum];
/**
 * @export
 */
export const CreateCustomerOrderEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateCustomerOrderEventContentTypeEnum = typeof CreateCustomerOrderEventContentTypeEnum[keyof typeof CreateCustomerOrderEventContentTypeEnum];
/**
 * @export
 */
export const CreateCustomerOrderEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateCustomerOrderEventAcceptEnum = typeof CreateCustomerOrderEventAcceptEnum[keyof typeof CreateCustomerOrderEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnCustomerOrderByIdAcceptEnum = typeof GetChangeRequestOnCustomerOrderByIdAcceptEnum[keyof typeof GetChangeRequestOnCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const GetCustomerOrderACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetCustomerOrderACLAuthorizationByMemberIdAcceptEnum = typeof GetCustomerOrderACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetCustomerOrderACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetCustomerOrderACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetCustomerOrderACLByIdAcceptEnum = typeof GetCustomerOrderACLByIdAcceptEnum[keyof typeof GetCustomerOrderACLByIdAcceptEnum];
/**
 * @export
 */
export const GetCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetCustomerOrderByIdAcceptEnum = typeof GetCustomerOrderByIdAcceptEnum[keyof typeof GetCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const GetCustomerOrderEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetCustomerOrderEventsAcceptEnum = typeof GetCustomerOrderEventsAcceptEnum[keyof typeof GetCustomerOrderEventsAcceptEnum];
/**
 * @export
 */
export const GetCustomerOrderMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetCustomerOrderMetadataByIdAcceptEnum = typeof GetCustomerOrderMetadataByIdAcceptEnum[keyof typeof GetCustomerOrderMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfCustomerOrderByIdAcceptEnum = typeof ListChangeRequestsOfCustomerOrderByIdAcceptEnum[keyof typeof ListChangeRequestsOfCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const PatchCustomerOrderByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchCustomerOrderByIdContentTypeEnum = typeof PatchCustomerOrderByIdContentTypeEnum[keyof typeof PatchCustomerOrderByIdContentTypeEnum];
/**
 * @export
 */
export const PatchCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchCustomerOrderByIdAcceptEnum = typeof PatchCustomerOrderByIdAcceptEnum[keyof typeof PatchCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const SearchCustomerOrderGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchCustomerOrderGetAcceptEnum = typeof SearchCustomerOrderGetAcceptEnum[keyof typeof SearchCustomerOrderGetAcceptEnum];
/**
 * @export
 */
export const SearchCustomerOrdersPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchCustomerOrdersPostContentTypeEnum = typeof SearchCustomerOrdersPostContentTypeEnum[keyof typeof SearchCustomerOrdersPostContentTypeEnum];
/**
 * @export
 */
export const SearchCustomerOrdersPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchCustomerOrdersPostAcceptEnum = typeof SearchCustomerOrdersPostAcceptEnum[keyof typeof SearchCustomerOrdersPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnCustomerOrderByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnCustomerOrderByIdContentTypeEnum = typeof UpdateChangeRequestOnCustomerOrderByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnCustomerOrderByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnCustomerOrderByIdAcceptEnum = typeof UpdateChangeRequestOnCustomerOrderByIdAcceptEnum[keyof typeof UpdateChangeRequestOnCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const UpdateCustomerOrderByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateCustomerOrderByIdContentTypeEnum = typeof UpdateCustomerOrderByIdContentTypeEnum[keyof typeof UpdateCustomerOrderByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateCustomerOrderByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateCustomerOrderByIdAcceptEnum = typeof UpdateCustomerOrderByIdAcceptEnum[keyof typeof UpdateCustomerOrderByIdAcceptEnum];
/**
 * @export
 */
export const UpsertCustomerOrderACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertCustomerOrderACLAuthorizationByIdContentTypeEnum = typeof UpsertCustomerOrderACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertCustomerOrderACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertCustomerOrderACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertCustomerOrderACLAuthorizationByIdAcceptEnum = typeof UpsertCustomerOrderACLAuthorizationByIdAcceptEnum[keyof typeof UpsertCustomerOrderACLAuthorizationByIdAcceptEnum];
